import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

const quizDashboardMeta = {
    title: 'Quiz Dashboard',
    dataTablePage: true,
    middleware: [GateKeeperMiddleware],
    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a quiz attempt'),
};

export default [
    {
        name: 'quiz-dashboard',
        path: '/quiz-dashboard',
        component: () => import('@/pages/quiz-dashboard/QuizDashboard.vue'),
        props: true,
        meta: quizDashboardMeta,
    },
    // Course-scoped entry from the launched-course sidebar. Staying under
    // `/courses/:courseId` keeps the course menu (no Menu/reset) and the
    // collapsed icon rail instead of jumping to the global /quiz-dashboard.
    {
        name: 'course-quiz-dashboard',
        path: '/courses/:courseId/quiz-dashboard',
        component: () => import('@/pages/quiz-dashboard/QuizDashboard.vue'),
        props: true,
        meta: quizDashboardMeta,
    },
];
